var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { createContext, useReducer, useContext } from "react";
var initialAuthState = {
    user: null,
    profiles: [],
    profile: null,
    errorStatus: null,
};
var AuthContext = createContext(undefined);
var authReducer = function (state, action) {
    switch (action.type) {
        case "LOGIN":
            return __assign(__assign({}, state), { user: action.user });
        case "LOGOUT":
            return __assign({}, initialAuthState);
        case "SET_PROFILES":
            return __assign(__assign({}, state), { profiles: action.profiles });
        case "SET_PROFILE":
            return __assign(__assign({}, state), { profile: action.profile });
        default:
            return state;
    }
};
export var AuthProvider = function (_a) {
    var children = _a.children;
    var _b = useReducer(authReducer, initialAuthState), state = _b[0], dispatch = _b[1];
    return (React.createElement(AuthContext.Provider, { value: { state: state, dispatch: dispatch } }, children));
};
export var useAuth = function () {
    var context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuth must be used within an AuthProvider");
    }
    var state = context.state, dispatch = context.dispatch;
    return {
        user: state.user,
        profiles: state.profiles,
        profile: state.profile,
        dispatch: dispatch,
    };
};



//////////////////
// WEBPACK FOOTER
// ./src/context/Auth.tsx
// module id = 6
// module chunks = 1